<script>
  import MemoryListItem from "./MediaDisplay/MemoryListItem.svelte";
</script>

<main>
  <wide>
    <MemoryListItem memoryUUID='383BFF3D-C8D2-41ED-829E-A0A868970696'/><!--Grays-->
    <MemoryListItem memoryUUID='6F598324-D966-4389-87B5-5AB8A41755B8'/><!--SnowMountainRanch-->
    <MemoryListItem memoryUUID='D81EAA03-1FAF-489C-B6D1-D2F5ECD5C615'/><!--Boulder Canyon-->
    <MemoryListItem memoryUUID='7ADDD607-006C-44B8-84DF-EDE6F936E0DE'/><!--Haircut-->
    <MemoryListItem memoryUUID='6B21B418-A8A5-40CF-B955-B49FC0DAB7DE'/><!--KelsoRidge-->
    <MemoryListItem memoryUUID='DF6CB0AF-452C-4119-A5A3-F97ABDB02971'/><!--Timing Job -->
    <MemoryListItem memoryUUID='1A6A82A2-BF9C-4258-8C6F-2FBDDCCF6873'/><!--LaPlata-->
  </wide>
</main>

<style>
  main {
    width: 100%;
    height: 100%;
    padding-left: 1rem; padding-right: 1rem;
    overflow-x: visible;
  }
  main h2 {
    text-align: left;
    margin-bottom: 0px;
    padding-bottom: 0px;
  }
  p {
    margin-top: 30px;
  }

  wide {
    width: 100vw;
    height: auto;
    position: relative;
    margin-left: -50vw;
    margin-right: -50vw;
  }
  wide p {
    width: 100%;
    overflow-x: hidden;
  }

  dividerLine {
    background-color: rgba(107,118,141,0.3);
    width: 300px;
    height: 100px;
    margin-top: 20px;
    margin-bottom:20px;
  }

  @media screen and (max-width: 1000px){
    h1 { font-size: 2.0rem; }
    h2 { font-size: 1.8rem; }
  }
  @media screen and (max-width: 600px){
    h1 { font-size: 1.7rem; }
    h2 { font-size: 1.4rem; }
  }
</style>
